import React, { useState } from 'react'
import ScholarzLogo from '../../assets/icons/scholarz-logo.png'
import { SchTabItem } from '../../components/shared/atoms'
import { FullWidthWrapper } from '../../components/shared/layouts'
import { SchTab } from '../../components/shared/molecules'
import { LaboratoryChecker, LandClaim, TraitChecker } from '../../components/TabItems'
import { tabs } from '../../components/utils'
import Wrapper from './style'

const Main = ({className}) => {
	const [active, setActive] = useState(tabs[0])

	return (
		<FullWidthWrapper className={className}>
			<Wrapper>
				<img
					src={ScholarzLogo}
					alt="logo"
					className="logo"
				/>
				<div className="title">Scholarz Helper</div>
				<SchTab>
					{tabs.map((item) => {
						return (
							<SchTabItem
								key={item}
								selected={active === item}
								onClick={() => setActive(item)}
							>
								{item}
							</SchTabItem>
						)
					})}
				</SchTab>
				<div className="desc">
					{active === tabs[0]
						&& <>Check if a Scholarz still has available land to claim!</>
					}
					{active === tabs[1]
						&& <>Peek inside other laboratories and see what they have!</>
					}
					{active === tabs[2]
						&& <>Check your Candidate traits. See how they look before building one!</>
					}
				</div>
				<div className="content">
					{active === tabs[0]
						&& <LandClaim/>
					}
					{active === tabs[1]
						&& <LaboratoryChecker/>
					}
					{active === tabs[2]
						&& <TraitChecker/>
					}
				</div>
			</Wrapper>
		</FullWidthWrapper>
	)
}

export default Main